import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	UpdatePendingRegularOrAdvanceInvoiceStatusToDraftPayload,
	UpdatePendingSelfBilledInvoiceStatusToDraftPayload,
} from "~/modules/billing/api/pendingInvoice/pendingInvoiceTypes.ts";
import type {
	PendingInvoicesIndexResponse,
	PendingInvoiceStatusReportData,
} from "~/modules/billing/api/unprocessedInvoicesTypes.ts";

const pendingInvoicesBasePath = "/invoices/pending";

export function indexPendingInvoices(): AxiosApiResponsePromise<PendingInvoicesIndexResponse> {
	return axiosApi.get(pendingInvoicesBasePath);
}

export function createOrUpdatePendingInvoiceComment(invoiceId: string, text: string): AxiosApiResponsePromise<void> {
	return axiosApi.patch(`${pendingInvoicesBasePath}/${invoiceId}/comment`, { text });
}

export function updatePendingRegularOrAdvanceInvoiceStatusToDraft(
	invoiceId: string,
	data: UpdatePendingRegularOrAdvanceInvoiceStatusToDraftPayload,
): AxiosApiResponsePromise<void> {
	return axiosApi.patch(`${pendingInvoicesBasePath}/${invoiceId}/regular/status`, data);
}

export function updatePendingSelfBilledInvoiceStatusToDraft(
	invoiceId: string,
	data: UpdatePendingSelfBilledInvoiceStatusToDraftPayload,
): AxiosApiResponsePromise<void> {
	return axiosApi.patch(`${pendingInvoicesBasePath}/${invoiceId}/self-billed/status`, data);
}

export function getPendingInvoiceStatusReport(invoiceId: string,
	deliveryStartDate: string,
	deliveryEndDate: string): AxiosApiResponsePromise<PendingInvoiceStatusReportData> {
	return axiosApi.post(`/invoices/${invoiceId}/delivery-period-check`, { deliveryStartDate, deliveryEndDate });
}